module.exports = __webpack_public_path__ + "static/img/Gubecka-Chelsea.50b6c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Gubecka-Chelsea.jpg
// module id = VRzW
// module chunks = 1